import {
  faCircleCheck,
  faCircleXmark,
  faSpinner
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'

const PreStreamVideo = () => {
  const {
    isLoading,
    updateSetting,
    [SETTINGS.VIDEO.key]: videos,
    [SETTINGS.IMAGES.key]: images,
    [SETTINGS.PRE_STREAM.key]: preStreamSettings
  } = useContext(SiteConfigContext)

  const [startSettings, setStartSettings] = useState(
    SETTINGS.PRE_STREAM.default
  )

  useEffect(() => {
    if (preStreamSettings) setStartSettings(preStreamSettings)
  }, [preStreamSettings])

  if (isLoading) {
    return (
      <h1 className="flex items-center">
        Loading...{' '}
        <FontAwesomeIcon
          icon={faSpinner}
          className="h-4 w-4 ml-2 animate-spin"
        />
      </h1>
    )
  }

  if (!videos?.prestream) {
    return (
      <Link to={'/mod/content/assets'}>
        <button className="flex w-fit button-fill" type="button">
          Upload a Pre-stream Video
        </button>
      </Link>
    )
  }

  if (!images?.starting) {
    return (
      <Link to={'/mod/content/assets'}>
        <button className="flex w-fit button-fill" type="button">
          Upload a Pre-stream Image
        </button>
      </Link>
    )
  }

  const updateStartSettings = async (updated) => {
    const videoDuration = await getVideoDuration(videos.prestream)

    const newSettings = {
      ...startSettings,
      ...updated,
      videoDuration: videoDuration
    }
    setStartSettings(newSettings)
    await updateSetting(SETTINGS.PRE_STREAM, newSettings)
  }

  const getVideoDuration = (url) =>
    new Promise((resolve, reject) => {
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.src = url

      video.addEventListener('loadedmetadata', () => {
        resolve(video.duration) // duration in seconds
      })

      video.addEventListener('error', (e) => {
        reject('Error loading video')
      })
    })

  return (
    <div className="flex flex-col gap-2">
      <h2>Pre-stream Settings</h2>

      <div className="mb-1">
        <label className="dark:text-neutral-100">Pre-stream Start Time</label>
        <input
          type="datetime-local"
          value={startSettings.startTime}
          onChange={(e) => updateStartSettings({ startTime: e.target.value })}
          className="grow input w-full"
        />
      </div>

      <div className="flex flex-row gap-2">
        <ActiveButton
          active={startSettings.enabled}
          handleActivate={async (enabled) => {
            await updateStartSettings({
              enabled
            })
          }}
        >
          {startSettings.enabled
            ? 'Pre-stream Video is Active'
            : 'Pre-stream Video is Inactive'}
        </ActiveButton>

        <Link to={'/mod/content/assets'}>
          <button className="flex button-fill w-fit" type="button">
            Edit Video
          </button>
        </Link>

        <Link to={'/mod/content/assets'}>
          <button className="flex button-fill w-fit" type="button">
            Edit Image
          </button>
        </Link>
      </div>
    </div>
  )
}

const ActiveButton = ({ children, active, handleActivate }) => (
  <label
    className={`cursor-pointer flex w-fit items-center justify-between px-3 py-2 gap-1.5 rounded border transition-all ${
      active
        ? 'bg-green-500/15 hover:bg-green-500/25 border-green-500/50'
        : 'bg-red-500/15 hover:bg-red-500/25 border-red-500/50'
    }`}
  >
    <p className="select-none">{children}</p>
    <input
      type="checkbox"
      checked={active}
      onChange={() => handleActivate(!active)}
      className="hidden"
    />
    <p className="sr-only">{active ? `on` : `off`}</p>
    <FontAwesomeIcon
      icon={active ? faCircleCheck : faCircleXmark}
      className={`${active ? 'text-green-500' : 'text-red-500'}`}
    />
  </label>
)

export default PreStreamVideo
